//handles redux exhibitor state
import {createSlice} from '@reduxjs/toolkit';

const initialStateValue = ''

export const exhibitorSlice = createSlice({
    name:"exhibitor",
    initialState:{value:initialStateValue},
    reducers:{
        rxExhibitor:(state,action)=>{
            if (action.payload===null){
                action.payload=''
            }
            state.value = action.payload
        },
    }
})

export const {rxExhibitor} = exhibitorSlice.actions

export default exhibitorSlice.reducer;
